import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutsModule } from "./layouts/layouts.module";
import { PagesModule } from "./pages/pages.module";
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PerfectScrollbarConfigInterface, PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { NgxPermissionsModule, NgxPermissionsService } from 'ngx-permissions';
import { ConfirmationPopoverModule } from 'angular-confirmation-popover';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { UserIdleModule } from 'angular-user-idle';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { SnotifyModule, SnotifyService, ToastDefaults } from 'ng-snotify';
import { CookieService } from 'ngx-cookie-service';
import { NgxMaskModule } from 'ngx-mask';
import { NgbModule, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from './shared/shared.module';
import { APP_BASE_HREF, CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { HttpService } from './shared/http.service';
import { SpinnerComponent } from './shared/spinner.component';
import { ConfirmationDialogComponent } from './shared/confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogService } from './shared/confirmation-dialog/confirmation-dialog.service';
import { CryptoService } from './shared/crypto/crypto.service';
import { LoginService } from './account/login/login.service';
import { AuthGuard, CanDeactivateGuard } from './core/guards/auth.guard';
import { ToastrModule } from 'ngx-toastr';
import { FilePickerService } from './shared/file-picker/file-picker.service';
import { ImagePickerService } from './shared/image-picker/image-picker.service';
import { AgGridSource } from './shared/ag-grid/ag-grid-source';
import { MatDialogModule } from '@angular/material/dialog';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelSpeed: 2,
  wheelPropagation: true,
  minScrollbarLength: 20
};

export function createNgxLoader(ngx: NgxPermissionsService, httpService: HttpService) {
  return () => {
    let menus = httpService.menus();
    if (menus && menus.length != 0) {
      let filteredMenus = menus.filter((x: { AccessTypeId: null; }) => x.AccessTypeId != null);
      let permissions: any[] = filteredMenus.map((x: { Id: any; }) => x.Id);
      return ngx.loadPermissions(permissions);
    }
  };
}

@NgModule({
  declarations: [
    AppComponent,
    SpinnerComponent,
    ConfirmationDialogComponent
  ],
  imports: [
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    LayoutsModule,
    PagesModule,
    Ng2SearchPipeModule,
    SharedModule,
    ConfirmationPopoverModule.forRoot({
      reverseButtonOrder:true
    }),
    CommonModule,
    FormsModule,
    NgbModule,
    NgbDatepickerModule,
    NgxPermissionsModule.forRoot(),
    NgxMaskModule.forRoot(),
    LoadingBarHttpClientModule,
    UserIdleModule.forRoot(environment.userIdle),
    LoggerModule.forRoot({
      serverLoggingUrl: environment.dataApiUrl + 'errorlog',
      level: NgxLoggerLevel.ERROR,
      serverLogLevel: NgxLoggerLevel.ERROR,
      disableConsoleLogging: true
    }),
    SnotifyModule,
  ],
  providers: [
    CanDeactivateGuard,
    FilePickerService,
    ImagePickerService,
    NgxPermissionsService,
    CookieService,
    SnotifyService,
    ConfirmationDialogService,
    CryptoService,
    LoginService,
    AuthGuard,
    AgGridSource,
    {
      provide: APP_INITIALIZER,
      useFactory: createNgxLoader,
      deps: [NgxPermissionsService, HttpService],
      multi: true
    },
    { provide: 'SnotifyToastConfig', useValue: ToastDefaults },
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    {
      provide: APP_BASE_HREF,
      useValue: '/'
    },
  ],
  entryComponents: [ConfirmationDialogComponent, MatDialogModule],
  bootstrap: [AppComponent]
})
export class AppModule { }
